class AdminEmailChange
  constructor: (@container) ->
    changer = @
    @person_email = @container.find('#person_email_to_verify')
    @person_submit = @container.find('input[type=submit]')
    @person_email.data('original-email', @person_email.val())
    @email_form()
    @person_email.change ->
      changer.email_form()


  email_form: ->
    if @person_email.val() != @person_email.data('original-email')
      @person_submit.val('save & send email')
      $('#label_for_new_email').html('Notify new address('+@person_email.val()+')')
      $('tr[data-behavior=notify-email]').show('slowly')
      $('#new_email').val(@person_email.val())
    else
      @person_submit.val('save')
      $('tr[data-behavior=notify-email]').hide('slowly')

$(document).ready ->
  $("*[data-behavior=AdminEmailChange]").each ->
    new AdminEmailChange($(@))
